import { useApp } from '../context/AppContext';

export function useEntries() {
  const { state } = useApp();
  return {
    entries: state.entries.filter(e => !e.isDraft),
    loading: state.loading,
  };
}
